export const BaseLayerLayerTypes = [
    "background",
    "road",
    "symbol",
    "label"
];
